import React, { PureComponent } from 'react'
import { APP_URL } from '../../utils/config.js'
import { connect } from 'react-redux'
import { withRoutingTracker } from '../../HOC/withRoutingTracker.js'
import Filters from './Filters.js'
import _, { cloneDeep } from 'lodash'
import { BarLoader } from 'react-spinners'
import { addToCart, setScrollPosition, setSingleFabric } from '../../actions/generalActions.js'
import {
  getFabricsForKits,
  getMoreFabrics,
  setFilteredFabrics,
} from '../../actions/fabricsActions.js'
import { createError, displayPromiseToast, displayToast, sendGtag, setURLParams } from '../../utils/utils.js'
import NewItemOverlay from '../NewItemOverlay.js'
import { NUMBER_OF_DAYS_FOR_NEW_ITEM } from '../../utils/constants.js'
import { formatPrice } from '../../utils/format'

class Fabrics extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isMobileLayout: false,
      isMobileDevice: false,
      favouriteFabrics: [],
      page: 1,
      isLoadingMoreFabrics: false,
      loadedAllFabrics: false,
      lastFabricsFilters: [],
    }

    this.fabricsList = React.createRef()
    this.fabricsContianer = React.createRef()
  }

  componentDidMount() {
    const { dispatch, history, switchCurrentView, fabrics, general } = this.props
    const userAgent = window.navigator.userAgent
    const mobileKeywords = ['Mobile', 'Android', 'iOS', 'Windows Phone']

    this.setState({
      isMobileLayout: window.innerWidth < 1024,
      isMobileDevice: mobileKeywords.some((keyword) => userAgent.includes(keyword)),
      favouriteFabrics: JSON.parse(localStorage.getItem('favourites')) || [],
    })
    const { filters } = fabrics
    const storedScrollPosition = general.scrollPosition || 0

    if (storedScrollPosition !== 0) {
      this.fabricsList.current.scrollTop = storedScrollPosition
    } else if (filters.length <= 2) {
      dispatch(getFabricsForKits())
    }
    this._checkForMobileLayout()
    window.addEventListener('resize', this._checkForMobileLayout)

    const fabricID = history.location.search.split('=')[1]
    if (fabricID) {
      dispatch(setSingleFabric(parseInt(fabricID)))
      switchCurrentView('single-fabric')()
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props
    const scrollPosition = this.fabricsList.current.scrollTop
    dispatch(setScrollPosition(scrollPosition))
    window.removeEventListener('resize', this._checkForMobileLayout)
  }

  _checkForMobileLayout = _.debounce(() => {
    this.setState({ isMobileLayout: window.innerWidth <= 1024 })
  }, 100)

  handleOpenFilters = () => {
    const { switchCurrentView } = this.props
    sendGtag('open_mobile_filters_fabrics')
    switchCurrentView('filters')()
  }

  _renderHeader = () => {
    const { isMobileLayout } = this.state
    return isMobileLayout ? (
      <div className="filters-button" onClick={this.handleOpenFilters}>
        <div>
          <img src={`${APP_URL}/wp-content/uploads/2021/10/filter.png`} />
          <span>FILTERS</span>
        </div>
        <img src={`${APP_URL}/wp-content/uploads/2021/10/arrow-right.png`} />
      </div>
    ) : (
      <Filters />
    )
  }

  _toggleFavouriteFabric = (fabricId, fabricName) => () => {
    const currentFavourites = JSON.parse(localStorage.getItem('favourites')) || []
    if (currentFavourites.includes(fabricId)) {
      const newFavourites = currentFavourites.filter((id) => id !== fabricId)
      localStorage.setItem('favourites', JSON.stringify(newFavourites))
      this.setState({ favouriteFabrics: newFavourites })
      sendGtag('favorites_fabrics', `${fabricName}_Favorite value 0`)
    } else {
      localStorage.setItem('favourites', JSON.stringify([...currentFavourites, fabricId]))
      this.setState({ favouriteFabrics: [...currentFavourites, fabricId] })
      sendGtag('favorites_fabrics', `${fabricName}_Favorite value 1`)
    }
  }

  _selectCushionFabric = (fabric) => () => {
    const { dispatch, history } = this.props
    dispatch(setSingleFabric(fabric))
    history.push('/fabrics?viewing=' + fabric)
  }

  addToCartCallback = () => {
    if (window?.increment_cart) {
      window.increment_cart()
    }
  }

  _getInfo = (fabric) => {
    const info = {}

    fabric.attributes?.forEach((attribute) => {
      const key = attribute?.name
        ?.split(' ')
        .map((word) => word.toLowerCase())
        .join('_')
      info[key] = attribute?.options.join(', ')
    })

    return info
  }

  _onBuySwatch = (fabric) => () => {
    const { dispatch, fabrics } = this.props
    const fabricSku = fabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'internal sku')
      ?.options[0]
    const fabricColor = fabric.attributes?.find(
      (attr) => attr.name.toLowerCase() === 'internal color number:',
    )?.options[0]
    const fabricBrand = fabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'brand')
      ?.options[0]
    const fabricName = fabric?.name

    const fabricMaterialName = fabric?.attributes
      ?.find((attr) => attr.name.toLowerCase() === 'material')
      ?.options[0].toLowerCase()
    const fabricMaterialID = fabrics.materials
      .map((material) => material.vals)
      .flat()
      .find((item) => item.name.toLowerCase() === fabricMaterialName)?.id

    const itemData = {
      is_swatch: true,
      pa_internal_sku: fabricSku,
      pa_attribute_brand: fabricBrand,
      pa_sku: fabric?.sku || '',
      pa_internal_color_number: fabricColor,
      pa_fabric_material: fabricMaterialID,
      product_name: fabricName,
      type: 'fabric',
    }

    let cartKey = localStorage.getItem('cartKey')

    sendGtag('buy_swatch_fabrics', fabric?.name)

    const info = Object.keys(fabric).length > 0 ? this._getInfo(fabric) : null

    sendGtag('add_to_cart', null, {
      currency: 'USD',
      value: parseFloat(formatPrice(info?.price_per_swatch).replace('$', '')),
      items: [
        {
          item_id: fabric?.sku,
          item_name: fabric?.name,
        },
      ],
    })

    dispatch(addToCart(cartKey, fabric, itemData, true, false, this.addToCartCallback))
  }

  _isSame = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].name !== arr2[i].name || arr1[i].value !== arr2[i].value) {
        return false
      }
    }
    return true
  }

  _findCommonElement = (arr1, arr2) => {
    for (let i = 0; i < arr1.length; i++) {
      for (let j = 0; j < arr2.length; j++) {
        if (arr1[i] === arr2[j]) {
          return arr1[i]
        }
      }
    }
  }

  _moreFabricsCall = (params) => {
    const { dispatch, fabrics } = this.props
    const { filters } = fabrics

    return getMoreFabrics(params)
      .then((res) => {
        this.setState({
          isLoadingMoreFabrics: false,
        })
        if (res) {
          const newFabrics = [...fabrics.filteredFabrics, ...res]
          const uniqueFabrics = newFabrics.reduce((acc, fabric) => {
            if (!acc.find((f) => f.id === fabric.id)) {
              acc.push(fabric)
            }
            return acc
          }, [])

          dispatch(setFilteredFabrics(uniqueFabrics))
          if (fabrics.filteredFabrics.length === uniqueFabrics.length) {
            !this.state.loadedAllFabrics && displayToast('No more fabrics to load', 'info')
            this.setState({
              loadedAllFabrics: true,
              lastFabricsFilters: filters,
            })
          }
        } else {
          !this.state.loadedAllFabrics && displayToast('No more fabrics to load', 'info')
          this.setState({
            loadedAllFabrics: true,
            lastFabricsFilters: filters,
          })
        }
      })
      .catch((err) => {
        createError(err)
        displayToast('Fetching more fabrics failed', 'error')
      })
  }

  _loadMoreFabrics = () => {
    const { fabrics } = this.props
    const { filters } = fabrics

    const posibleFilteredFabricsLength = Array(1000)
      .fill(0)
      .map((_, index) => index * 100 + 100)

    let copyOfFilteredFabricsLength

    copyOfFilteredFabricsLength = fabrics?.filteredFabrics?.length

    let commonValue = this._findCommonElement(posibleFilteredFabricsLength, [
      copyOfFilteredFabricsLength,
    ])

    const firstCharacter = commonValue?.toString()[0]

    this.setState(
      {
        page: Number(firstCharacter) + 1,
      },
      () => {
        const { page } = this.state
        this.setState({
          isLoadingMoreFabrics: true,
        })
        let params
        const fitlersCopy = cloneDeep(filters)
        fitlersCopy.push({
          name: 'per_page',
          value: 100,
        })
        fitlersCopy.push({
          name: 'page',
          value: page,
        })

        params = setURLParams('', fitlersCopy, 'search')

        if (!this.state.loadedAllFabrics) {
          displayPromiseToast(this._moreFabricsCall(params), {
            success: 'Fabrics Loaded',
            pending: 'Loading Fabrics...',
            error: 'Something went wrong',
          })
        }
      },
    )
  }

  _scrollDetector = () => {
    if (this.fabricsList.current) {
      const { scrollTop, scrollHeight, clientHeight } = this.fabricsList.current
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 300

      // Load more fabrics if the scroll hit the bottom
      if (isAtBottom && !this.state.isLoadingMoreFabrics) {
        this._loadMoreFabrics()
      }

      if (scrollTop + clientHeight === scrollHeight) {
        if (window.innerWidth <= 375) {
          setTimeout(() => {
            this.fabricsList.current.style.overflow = 'hidden'
          }, 100)
          setTimeout(() => {
            this.fabricsList.current.style.overflow = 'auto'
          }, 750)
        }
      }
    }
  }

  _renderFabrics = () => {
    const { favouriteFabrics, isMobileDevice } = this.state
    const { general, fabrics, params } = this.props
    const { fabric, cordFabric, addedToCartMessages } = general
    let currentSelection = params.style ? cordFabric?.id : fabric?.id

    let fabricsArray = []

    if (fabrics.filteredFabrics) {
      fabricsArray = [
        ...fabricsArray,
        ...fabrics.filteredFabrics.map((fabric, index) => {
          const isFavorite = favouriteFabrics.includes(fabric?.id)

          return (
            <div id={`fabric-${fabric?.id}`} key={fabric?.id} className="fabric-container">
              <div className="fabric-hover-background" />
              <div
                className={`cushion-fabric-selector-card ${currentSelection === fabric.id || isMobileDevice ? 'active' : ''}  ${isFavorite ? 'favourite' : ''}`}
              >
                <img
                  id={`fabric-img-${fabric?.id}`}
                  src={fabric?.images[0]?.src}
                  onClick={this._selectCushionFabric(fabric?.id)}
                />
                <button id={`swatch-${index}`} onClick={this._onBuySwatch(fabric)} type="button">
                  {addedToCartMessages[fabric?.id] ? (
                    <span>
                      ADDED TO CART
                      <img
                        className="cart-img"
                        src={`${APP_URL}/wp-content/uploads/2021/12/check.png`}
                      />
                    </span>
                  ) : (
                    'BUY SWATCH'
                  )}
                </button>
                <div className="favourite-button-container">
                  <img
                    id={`img-checkbox-${index}`}
                    onClick={this._toggleFavouriteFabric(fabric?.id, fabric?.name)}
                    className={`favourite-button ${isFavorite ? 'favourite-button-visible' : ''}`}
                    src={`${APP_URL}/wp-content/uploads/2021/11/${isFavorite ? 'heart-full' : 'heart'}.svg`}
                  />
                </div>
                <NewItemOverlay
                  startDate={fabric.date_created}
                  daysOffBeingNew={NUMBER_OF_DAYS_FOR_NEW_ITEM}
                />
              </div>
              <span
                title={`${fabric?.name}`}
                className={'cushion-fabric-selector-card-name-overlay'}
              >
                {fabric?.name}
              </span>
            </div>
          )
        }),
      ]
    }

    if (fabrics.filteredFabrics.length === 0) {
      fabricsArray = [
        <div className="no-fabrics-message" key={0}>
          <p>There are no fabrics that fit the criteria at this time.</p>
        </div>,
      ]
    }

    return fabricsArray
  }

  componentDidUpdate(prevProps) {
    const { fabrics, location, history, switchCurrentView } = this.props
    if (!this._isSame(fabrics.filters, prevProps.fabrics.filters)) {
      this.setState({ page: 1 })
    }

    if (fabrics.filters !== this.state.lastFabricsFilters) {
      this.setState({
        loadedAllFabrics: false,
      })
    }

    if (location !== prevProps.location && history.location.search !== '') {
      switchCurrentView('single-fabric')()
    }
  }

  render() {
    const { isMobileLayout } = this.state
    const { fabrics } = this.props

    return (
      <div
        className="cushion-fabric-selector-container cushion-designer-layout"
        ref={this.fabricsContianer}
      >
        <h1 className="cushion-fabric-header-title">Fabric by the Yard</h1>
        <div></div>
        <div className="cushion-fabric-header-seo">
          <p>
            Each fabric image represents its respective fabric color, however due to monitor
            resolution, browser rendering, etc., Cushion Pros highly recommends ordering fabric
            swatches 2&quot; x 3&quot; in size first via the Fabric tab.
          </p>
          <p>
            Cushion Pros does not endorse machine washing any of the fabrics offered; see cleaning
            recommendations per each Vendors&apos; fabric when selecting.
          </p>
        </div>
        {this._renderHeader()}
        <div
          className={`${
            fabrics.filteredFabrics.length === 0
              ? 'cushion-fabric-selector block'
              : 'cushion-fabric-selector'
          } ${this.state.isLoadingMoreFabrics ? 'loading-more-fabrics' : ''}`}
          ref={this.fabricsList}
          onScroll={this._scrollDetector}
        >
          {!fabrics.fetchedFabrics || fabrics.fetchingFabrics ? (
            <BarLoader
              color={'#93C44E'}
              css={
                isMobileLayout
                  ? { position: 'absolute', left: '35%', rigth: '50%', bottom: '-10px' }
                  : { position: 'absolute', left: '50%', rigth: '50%' }
              }
            />
          ) : (
            this._renderFabrics()
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  fabrics: state.fabrics,
})

export default withRoutingTracker(connect(mapStateToProps)(Fabrics))
